import styles from './Logo.module.scss';
import PropTypes from 'prop-types';
import {IMAGE_ALT} from '../../constants';

const Logo = (props) => {
  const { image } = props;
  return <img className={styles.logo} alt={IMAGE_ALT.ALL_SPARK} src={image}></img>;
};

Logo.propTypes = {
  handle: PropTypes.func,
};

export default Logo;
